module.exports = __webpack_public_path__ + "img/fenxiang@3x.9447e225.png";